import React, { useState } from 'react';


export default function TeacherLogin() {
const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
const [error, setError] = useState('');


async function onSubmit(e) {
  e.preventDefault();
  setError('');
  const res = await fetch('/api/auth/qut/teacher', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, password }) });
  const data = await res.json();
  if (!res.ok) return setError(data.message || data.error || 'Login failed');
  if (data.token) localStorage.setItem('token', data.token);
  window.location.href = data.redirect || '/instructor';
}


return (
<form onSubmit={onSubmit} className="emap-auth-card emap-teacher-form">
<h1 className="text-xl mb-4">Teacher Login</h1>
<input className="border p-2 w-full mb-3" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} />
<input className="border p-2 w-full mb-3" type="password" placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)} />
{error && <p className="text-red-600 mb-2">{error}</p>}
<button className="border px-4 py-2 w-full" type="submit">Sign in</button>
<a className="block text-center mt-3 underline" href="/api/auth/google/teacher">Sign in with Google</a>
<a className="block text-center mt-3 underline" href="/api/auth/microsoft">Sign in with Microsoft</a>
</form>
);
}
